import { Button, Modal, Typography } from 'components';
import { CloseIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC, useRef } from 'react';
import { cn } from 'utils/cn';

interface IModalManageTaskPrompt {
  open: boolean;
  onCancel: () => void;
}

const ModalManageTaskPrompt: FC<IModalManageTaskPrompt> = ({ open, onCancel }) => {
  const t = useTranslations();

  const refModal = useRef<HTMLDivElement>(null);

  const handleSave = () => {};

  return (
    <Modal
      zDialog={cn('!z-[1999]')}
      zDialogBackdrop="z-[1000]"
      onClose={onCancel}
      open={open}
      className={'w-[572px]'}
    >
      <div
        className={cn(
          'overflow-y-auto p-6',
          'relative flex w-full flex-col gap-4 rounded bg-white shadow-custom'
        )}
        ref={refModal}
      >
        <div className="absolute right-2 top-2 z-[1000]">
          <Button
            size="small"
            variant="icon"
            color="neutral"
            className="!w-8 rounded-full"
            onClick={onCancel}
            startAdornment={<CloseIcon />}
          />
        </div>
        <div className="flex flex-col">
          <Typography variant="medium4xl" className="text-tertiary-100 ">
            {t('chat.manage_task_prompt.title')}
          </Typography>
          <div className="mt-6 flex justify-end">
            <Button
              size="large"
              variant="text"
              className="!w-8 rounded-full"
              onClick={onCancel}
              label={t('buttons.cancel')}
            />
            <Button
              // disabled={isDisabledUpload}
              size="large"
              variant="contained"
              className="!w-8 rounded-full"
              onClick={handleSave}
              label={t('buttons.save')}
              // loading={uploading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalManageTaskPrompt;
